'use client';

import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { useRouter } from 'src/routes/hooks';
import { DashboardLayout } from 'src/layouts/dashboard';
import { BlankView } from 'src/sections/blank/view';
import { HomeHero } from 'src/sections/home';
import { SplashScreen } from 'src/components/loading-screen';
import { CONFIG } from 'src/global-config';
import { Styling } from '../sections/dashboard/view';
import {AppDashboardGamla} from "src/sections/dashboard/view/app-dashboard-gamla";

// ----------------------------------------------------------------------

export default function Page() {
  const { user, authenticated, loading } = useAuthContext();
  const router = useRouter();

  useEffect(() => {
    if (!loading) {
      if (!authenticated) {
        router.replace('/logga-in');
      } else if (user) {
        const emailVerified = user.emailVerified;
        if (!emailVerified) {
          router.replace('/verifiera');
        }
      }
    }
  }, [loading, authenticated, user, router]);

  if (loading || !authenticated) {
    return <SplashScreen />;
  }

  return (
    <DashboardLayout>
      <AppDashboardGamla />
    </DashboardLayout>
  );
}
